import React from 'react';
import { CnProgress } from '@cainiaofe/cn-ui';
import { CnStatisticProgressProps } from './types';
import CnStatisticProgressBase from './base';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticProgress({
  percent,
  shape,
  color,
}: CnStatisticProgressProps) {
  return <CnProgress percent={percent} shape={shape} color={color} />;
}

export { CnStatisticProgress };
export type { CnStatisticProgressProps };
